import React, { Component } from "react";
import { Spin } from "antd";
import Swal from "sweetalert2";
import "../ORDER/OrderMaster/style.css";
import "antd/dist/antd.css";

const API_BASE = "https://api.blumangoes.ai:6143";
const DB = "IMAGEDB";
const CONCURRENCY = "300";
const POLL_INTERVAL_MS = 3000;

export default class frmExcelLinkValidator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadFile: null,
      loading: false,
    };
    this.pollInterval = null;
  }

  componentWillUnmount() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  }

  handleFileUpload = (e) => {
    this.setState({ uploadFile: e.target.files[0] });
  };

  validateLinks = async () => {
    const token = localStorage.getItem("authToken1");

    if (!token) {
      Swal.fire("Unauthorized", "Please login again", "error");
      return;
    }

    if (!this.state.uploadFile) {
      Swal.fire("Warning", "Please choose an Excel or CSV file first", "warning");
      return;
    }

    try {
      this.setState({ loading: true });

      const formData = new FormData();
      formData.append("file", this.state.uploadFile);
      formData.append("concurrency", CONCURRENCY);

      const response = await fetch(
        `${API_BASE}/validate-image-urls?db=${DB}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || "API error");
      }

      const jobId = data.job_id;
      if (!jobId) throw new Error("Job ID missing in response");

      this.pollStatus(jobId, token);
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
      Swal.fire("Error", error.message, "error");
    }
  };

  pollStatus = (jobId, token) => {
    this.pollInterval = setInterval(async () => {
      try {
        const response = await fetch(
          `${API_BASE}/job-status/${jobId}?db=${DB}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await response.json();

        const state = (data.state || "").toUpperCase();

        if (state === "SUCCESS" || state === "COMPLETED") {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
          await this.downloadResult(jobId, token, !!data.zip_file);
        }

        if (state === "FAILURE" || state === "FAILED" || state === "ERROR") {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
          this.setState({ loading: false });
          Swal.fire(
            "Error",
            data.error || data.message || "Validation failed",
            "error"
          );
        }
      } catch (err) {
        console.log("Polling error:", err.message);
      }
    }, POLL_INTERVAL_MS);
  };

  triggerDownload = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  downloadResult = async (jobId, token, hasZip = false) => {
    try {
      const excelResp = await fetch(
        `${API_BASE}/download/${jobId}?db=${DB}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!excelResp.ok) throw new Error("Excel download failed");
      this.triggerDownload(await excelResp.blob(), "LinkValidationResult.xlsx");
    } catch (err) {
      console.error("Excel download error:", err);
      this.setState({ loading: false });
      Swal.fire("Error", err.message || "Excel download failed", "error");
      return;
    }

    let zipDownloaded = false;
    if (hasZip) {
      try {
        const zipResp = await fetch(
          `${API_BASE}/download-images/${jobId}?db=${DB}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (zipResp.ok) {
          this.triggerDownload(await zipResp.blob(), "ValidImages.zip");
          zipDownloaded = true;
        }
      } catch (e) {
        console.warn("ZIP download failed:", e.message);
      }
    }

    this.setState({ loading: false });
    Swal.fire({
      icon: "success",
      title: "Validation Complete",
      text: zipDownloaded
        ? "Excel result and images ZIP downloaded."
        : hasZip
        ? "Excel downloaded. Images ZIP could not be retrieved."
        : "Excel downloaded. No valid images were found for ZIP.",
    });
  };

  render() {
    return (
      <div className="content-wrapper">
        {this.state.loading && (
          <div className="loader">
            <div className="loader-item" style={{ marginLeft: "75vh" }}>
              <Spin tip="Validating links and downloading images, please wait..." />
            </div>
          </div>
        )}

        <section className="content">
          <div className="box box-success" style={{ marginTop: "-13px" }}>
            <div className="box-header with-border" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '12px 20px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, color: '#aaa', marginBottom: 3 }}>
                  Dashboard &gt; Image Tools &gt; Excel Link Validator
                </div>
                <h3 className="box-title" style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
                  EXCEL LINK VALIDATOR
                </h3>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
              </div>
            </div>

            <div className="box-body">
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-6 margintop">
                  <label>Upload Excel File *</label>
                  <input
                    type="file"
                    accept=".xlsx,.xlsm,.csv"
                    className="form-control"
                    onChange={this.handleFileUpload}
                  />
                </div>

                <div className="col-xs-12" style={{ marginTop: "30px" }}>
                  <div className="text-center">
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={this.validateLinks}
                      disabled={this.state.loading}
                    >
                      VALIDATE LINKS
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
